import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import { hmrBootstrap } from './hmr';

import * as Sentry from '@sentry/angular-ivy';

// Inicializa Sentry
Sentry.init({
  dsn: 'https://d981f9e26bbe48ff8df35bcea413e602@sentry.toroinvestimentos.com.br/48',
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: [
        /^http:\/\/localhost/,
        // /^https:\/\/api-hml\.toroinvestimentos\.com\.br/,
        // /^https:\/\/api\.toroinvestimentos\.com\.br/,
        // COMENTADO PARA EVITAR QUE O SENTRY INTERFIRA NAS REQUISIÇÕES DA API DURANTE OS TESTES,
        // POIS ESTÁ CAUSANDO PROBLEMAS DE CORS NA API DO PROFILE/OQ
      ],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],
  tracesSampleRate: 0.10,
});

if (environment.production) {
  enableProdMode();
}

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule);

if (environment.hmr) {
  if (module[ 'hot' ]) {
    hmrBootstrap(module, bootstrap);
  } else {
    console.error('HMR is not enabled for webpack-dev-server!');
    console.log('Are you using the --hmr flag for ng serve?');
  }
} else {
  document.addEventListener('DOMContentLoaded', () => {
    bootstrap()
  })
}
